<template>
  <div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.queryShort()
  },
  methods: {
    queryShort() {
      if (this.$route.params.id) {
        ajax.get({
          url: `/customer/common/queryShort/${this.$route.params.id}`,
          success: (res) => {
            if (res && typeof res === "string") {
              window.fixOpen(res, "_self")
            } else {
              window.location.href = '#/404'
            }
          },
        })
      }

    }
  },
}
</script>
<style scoped lang='less'></style>